var ActivityLinkView = require('./activity-link-view');
var PageService = require('services/page-service');
var ContentService = require('services/content-service');
var View = require('views/base/view');

var ActivityItemView = View.extend({
  noWrap: true,
  regions: {
    'activity-link': '.activity-link'
  },
  template: require('./templates/activity-item'),
  initialize: function(options) {
    View.prototype.initialize.apply(this, arguments);
    var self = this;
    this.model.set('id', options.model.get('key'));
    this.model.set('module_key', options.model.get('moduleKey'));
    this.model.set('show_pages', options.showPages);
    this.model.set('disable_if_locked', options.disableIfLocked);
    this.model.set('activity_link_class', options.activityLinkClass);

    this.on('addedToParent', function() {
      self.container = self.el;
      var linkView = new ActivityLinkView({
        model: self.model,
        region: 'activity-link',
        activityTemplate: options.activityTemplate
      });
      self.subview('activityLink', linkView);
    });
  },
  getTemplateData: function() {

    var obj    = this.model.serialize();
    obj.module = this.model.get('module_key');
    if (EF.module) {
      if(EF.module.currentActivity.get('key') == obj.id && EF.module.currentActivity.get('moduleKey') === obj.module ) {
        obj.status = 'active';
        obj.current = true;
      }
    }
    var currentModule = EF.modules.find(module => module.get('key') === this.model.get('module_key'));
    var isLocked = this.model.get('disable_if_locked') && !currentModule.get('unlocked');
    if(currentModule) {
      var activities = currentModule.activities;
      var activity = activities.get(obj.id);
      if(activity.isComplete()) {
        obj.status = 'complete';
      }
      if(isLocked && !EF.enrollment.get('demoMode')) {
        obj.disabled = true;
      }
    }
    if(this.model.get('show_pages')) {
      obj.pages = this.model.get('pages').toJSON().filter(page=> {
        const pageContent = ContentService.moduleContent[page.moduleKey][page.activityKey][page.key];
        if (!page.hide_in_menu && pageContent && pageContent.skip) {
          page.hide_in_menu = PageService.shouldSkipLearner(pageContent.skip);
        }
        return !page.hide_in_menu;
      });
      _.each(obj.pages, (page) => {
        if(activities.get(obj.id).isPageComplete(page.key) || !PageService.shouldPreventPageSkipping()) {
          page.status = 'completed';
          page.disabled = false;
        }else if (EF.enrollment.get('demoMode')){
          page.status = '';
          page.disabled = false;
        } else {
          page.status = 'incomplete';
          page.disabled = true;
        }
      });

      if(isLocked && !EF.enrollment.get('demoMode')) {
        _.each(obj.pages, function(page) {
          page.disabled = true;
        });
      }

      if(obj.current) {
        var currentPage = obj.pages.find(function(page) {
          return page.key === EF.module.currentActivity.currentPage.id;
        });
        if(currentPage) {
          currentPage.current = true;
          currentPage.disabled = false;
        }
      }
    }

    return obj;
  }
});

module.exports = ActivityItemView;
